import React from 'react';
import PropTypes from 'prop-types';
import LightboxComponent from '../lightbox/lightbox';
import InputLayer from './input_layer';
import ConfirmationLayer from './confirmation_layer';
import { isConfiguratorMotoTyreEnabled } from '../../../_views/configurator/common';
import {
  hideInfoLayerAction,
  hideVehicleNotProvidedLayerAction,
  showVehicleNotProvidedLayerAction,
} from '../../actions/rego_lookup_actions';
import VehicleNotProvidedLayer from './vehicle_not_provided_layer';
import {
  onOpenDefaultLayerConfigurator,
  onOpenTyreSizeConfiguratorClick,
} from '../../../_views/configurator_buttons/configurator_buttons';
import { applyFilters } from '../../helper/apply_filters';
import InfoLayer from '../catalog_configurator/info_layer';

function getActiveLightboxPage(state) {
  if (state.infoLayerVisible) {
    return 'info-layer';
  } else if (state.confirmationLayerVisible) {
    return 'confirmation-layer';
  } else if (state.vehicleNotProvidedLayerVisible) {
    return 'vehicle-not-provided-layer';
  }
  return 'input-layer';
}

function RegoLookup(props) {
  const configuratorMotoTyreEnabled = isConfiguratorMotoTyreEnabled();
  const fromTyreSize = props.state.fromTyreSize;
  const isCheckoutConfigurator = location.pathname.indexOf('/checkout/') !== -1 || fromTyreSize;
  const configuratorSticky = location.href.indexOf('configurator_sticky=1') !== -1;

  const onCloseDialog = () => {
    if (configuratorSticky) {
      return;
    }
    hideInfoLayerAction();
    if (isCheckoutConfigurator) {
      if (!props.state.vehicleNotProvidedLayerVisible && props.isVehicleProvided === null) {
        if (location.pathname.indexOf('/checkout/') !== -1) {
          showVehicleNotProvidedLayerAction();
        } else {
          props.onClose();
        }
      } else if (props.isVehicleProvided !== null) {
        props.onClose();
      }
    } else {
      props.onClose();
    }
  };

  const unsetVehicle = () => {
    if (fromTyreSize) {
      applyFilters('tyre');
    }
  };

  const onChangeCantProvideVehicle = () => {
    if (!props.state.vehicleNotProvidedLayerVisible) {
      if (location.pathname.indexOf('/checkout/') === -1) {
        unsetVehicle();
      } else {
        showVehicleNotProvidedLayerAction();
      }
    } else {
      hideVehicleNotProvidedLayerAction();
    }
  };

  return (
    <LightboxComponent
      hideCloseButton={configuratorSticky || props.state.vehicleNotProvidedLayerVisible}
      additionalClassNames={['rego-lookup-configurator-lightbox']}
      opened={props.state.visible}
      activePage={getActiveLightboxPage(props.state)}
      onClose={onCloseDialog}
      showBackButton={fromTyreSize || !(isCheckoutConfigurator && !props.state.vehicleNotProvidedLayerVisible)}
      onBack={
        props.state.infoLayerVisible
          ? hideInfoLayerAction
          : props.state.vehicleNotProvidedLayerVisible
          ? hideVehicleNotProvidedLayerAction
          : fromTyreSize
          ? onOpenTyreSizeConfiguratorClick
          : onOpenDefaultLayerConfigurator
      }
    >
      <div className="rego-lookup-configurator">
        {!props.state.vehicleNotProvidedLayerVisible && !props.state.confirmationLayerVisible && (
          <InputLayer
            isRegoLookupV2={props.state.visibleV2}
            filters={props.state.values}
            onChange={props.onChange}
            stateOptions={props.stateOptions}
            onSubmit={props.onSubmit}
            registrationInvalid={props.state.registrationInvalidMessage}
            licenceNotFound={props.state.licenceNotFound}
            onRetry={props.onRetry}
            buttonContinueDisabled={props.state.buttonContinueDisabled}
            inputStateVisible={props.state.inputStateVisible}
            configuratorMotoTyreEnabled={configuratorMotoTyreEnabled}
            onBlur={props.onBlurRego}
            isCheckoutConfigurator={isCheckoutConfigurator}
            fromTyreSize={fromTyreSize}
            onChangeCantProvideVehicle={onChangeCantProvideVehicle}
          />
        )}
        {!props.state.vehicleNotProvidedLayerVisible && props.state.confirmationLayerVisible && (
          <ConfirmationLayer
            isRegoLookupV2={props.state.visibleV2}
            onSelectVehicle={props.onSelectVehicle}
            vehicleData={props.state.vehicleData}
            filters={props.state.values}
            tyreOptions={props.state.tyreOptions}
            onChange={props.onChange}
            onSubmitShop={props.onSubmitShop}
            postcodeInvalid={props.state.postcodeInvalidMessage}
            onEdit={props.onEdit}
            onShowTyres={props.onShowTyres}
            buttonConfirmIsShown={props.state.buttonConfirmIsShown}
            onShowInfo={props.onShowInfo}
            buttonConfirmDisabled={props.state.buttonConfirmDisabled}
            configuratorMotoTyreEnabled={configuratorMotoTyreEnabled}
            selectPostcodeSuggestion={props.selectPostcodeSuggestion}
            store={props.store}
            onBlur={props.onBlurPostcode}
            isCheckoutConfigurator={isCheckoutConfigurator}
            fromTyreSize={fromTyreSize}
            onChangeCantProvideVehicle={onChangeCantProvideVehicle}
          />
        )}
        {props.state.vehicleNotProvidedLayerVisible && (
          <VehicleNotProvidedLayer filters={props.state.values} onChange={props.onChange} fromTyreSize={fromTyreSize} />
        )}

        <InfoLayer
          type="rego"
          staticUrl={props.staticUrl}
          onBackClick={props.onBackClick}
          onShowSecondLayerClick={props.onShowSecondLayerClick}
        />
      </div>
    </LightboxComponent>
  );
}

RegoLookup.propTypes = {
  staticUrl: PropTypes.string.isRequired,
  state: PropTypes.object.isRequired,
  tyreOptions: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSubmitShop: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  onShowTyres: PropTypes.func.isRequired,
  onShowInfo: PropTypes.func.isRequired,
  onSelectVehicle: PropTypes.func.isRequired,
  stateOptions: PropTypes.array.isRequired,
};

export default RegoLookup;
